import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/workbenchNotice/list', data }),
	detail: data => http({ url: '/api/admin/v1/workbenchNotice/detail', data }),
	create: data => http({ url: '/api/admin/v1/workbenchNotice/create', data, tip: true }),
	update: data => http({ url: '/api/admin/v1/workbenchNotice/update', data, tip: true }),
	delete: data => http({ url: '/api/admin/v1/workbenchNotice/delete', data, tip: true }),
	toggleStatus: data => http({ url: '/api/admin/v1/workbenchNotice/toggleStatus', data, tip: true }),
};
